export default __webpack_public_path__ + "static/media/arrow.72c319b3.svg";